import { render, staticRenderFns } from "./InvoiceTemplate.vue?vue&type=template&id=4ee08a18&scoped=true"
import script from "./InvoiceTemplate.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee08a18",
  null
  
)

export default component.exports